import { render } from "./PdfAccountingHeader.vue?vue&type=template&id=4535319e&scoped=true&ts=true"
import script from "./PdfAccountingHeader.vue?vue&type=script&lang=ts"
export * from "./PdfAccountingHeader.vue?vue&type=script&lang=ts"

import "./PdfAccountingHeader.vue?vue&type=style&index=0&id=4535319e&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4535319e"]])

export default __exports__